import Configuration from '../configuration';
import { $httpProvider } from '../providers';

function getMessageCommune(codeInsee) {
  return $httpProvider()({
    method: 'GET',
    url: Configuration.getMessageCommune,
    params: {
      codeinsee: codeInsee,
      destinataire: 'ASSISTANCE_TNT'
    }
  }).then(r => r.data);
}

export default {
  getMessageCommune
};



// WEBPACK FOOTER //
// ./src/repositories/message.repository.js